<div #mapContainer class="map-container">
  <ix-button
    class="position-btn"
    title="Request positions of newly connected devices that have not yet shared their location"
    (click)="onLocateNewDevicesClick()"
    >Locate New Devices ({{ unknownDevicesNeverUpdatedCount }})</ix-button
  >
</div>

<div #popup class="ol-popup" [hidden]="!showPopup">
  <div>
    <span *ngFor="let deviceId of popupDeviceIds; let i = index">
      <span
        class="device-link"
        style="color: #007bff; cursor: pointer; text-decoration: underline"
        (click)="onDeviceClick(deviceId)"
      >
        {{ deviceId }}
      </span>
      <span *ngIf="i < popupDeviceIds.length - 1"> </span>
    </span>
  </div>
</div>
